import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box, Button, Card, Typography } from '@mui/material';
import { formatDuration, intervalToDuration } from 'date-fns';
import { fr } from 'date-fns/locale';
import React from 'react';
import ArrowReturnIcon from '../../../../../svg-icons/ArrowReturnIcon';

const SavOrderDelayOverDue = ({ savDelayOverDue, handleShowComponent }) => {
  const formatOverdueDays = () => {
    const duration = intervalToDuration({
      start: new Date(savDelayOverDue),
      end: new Date(),
    });

    return formatDuration(duration, {
      locale: fr,
      format: ['years', 'months', 'weeks', 'days'],
      zero: false,
      delimiter: ' et ',
    });
  };

  return (
    <>
      <Card
        elevation={5}
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
          padding: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button
            onClick={() => handleShowComponent(null)}
            variant="outlined"
            size="small"
            sx={{ position: 'absolute', top: 16, left: 16 }}
          >
            <ArrowReturnIcon fontSize="small" />
            <span style={{ marginLeft: 4, fontSize: '0.9em' }}>Retour</span>
          </Button>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <HighlightOffIcon fontSize="large" color="error" />
            <Typography color="primary">
              Délai pour une commande SAV gratuite dépassé
            </Typography>
          </Box>
        </Box>
      </Card>

      <Box
        sx={{
          mt: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <Typography variant="body1" align="center">
          Le délai pour une commande SAV gratuite est dépassé de{' '}
          <strong>{formatOverdueDays()}</strong>, souhaitez-vous quand même
          effectuer la commande SAV ?
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            color="info"
            onClick={() => handleShowComponent(null)}
          >
            Annuler
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleShowComponent('savOrder', true)}
          >
            Continuer
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default SavOrderDelayOverDue;
